<div class="d-flex flex-column justify-content-center align-items-center">
    <h3 style="color: #004F71">Add Component</h3>
    <form [formGroup]="form">
        <mat-form-field class="chips-autocomplete" appearance="outline">
            <mat-label>Add components</mat-label>
            <input
                #optionInput
                matInput
                placeholder="Add component tags separated by commas"
                [formControlName]="'newComponent'"
                class="flex-100"
                (keydown.enter)="onEnterKey($any($event))"/>
            <mat-error *ngIf="form.get('newComponent')?.hasError('required')">
                Component tag is required
            </mat-error>
            <mat-error *ngIf="form.get('newComponent')?.hasError('duplicateComponent')">
                Component tag(s) already exist: {{ form.get('newComponent')?.errors?.['duplicateComponent']?.value }}
            </mat-error>
        </mat-form-field>
<!--        <mat-form-field class="chips-autocomplete" appearance="outline">-->
<!--            <mat-label>Choose components</mat-label>-->

<!--            <mat-chip-grid #chipGrid aria-label="Selected options">-->
<!--                <mat-chip-row *ngFor="let component of selectedComponents"-->
<!--                          removable="true"-->
<!--                          (removed)="remove(component)">-->
<!--                    {{ component }}-->
<!--                    <button matChipRemove matTooltip="Remove {{ component }}">-->
<!--                        <mat-icon>cancel</mat-icon>-->
<!--                    </button>-->
<!--                </mat-chip-row>-->

<!--                <input-->
<!--                    #optionInput-->
<!--                    matInput-->
<!--                    placeholder="Add components"-->
<!--                    [formControlName]="'newComponent'"-->
<!--                    [matAutocomplete]="auto"-->
<!--                    [matChipInputFor]="chipGrid"-->
<!--                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"-->
<!--                    [matChipInputAddOnBlur]="true"-->
<!--                    (matChipInputTokenEnd)="add($event)" />-->

<!--            </mat-chip-grid>-->

<!--            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">-->
<!--                <mat-option *ngFor="let component of allowedComponents" [value]="component.tag">-->
<!--                    {{ component.tag }}-->
<!--                </mat-option>-->
<!--                <mat-option *ngIf="allowedComponents?.length === 0">-->
<!--                    No matching options-->
<!--                </mat-option>-->
<!--            </mat-autocomplete>-->
<!--        </mat-form-field>-->
    </form>
    <div mat-dialog-actions class="buttons-offset">
        <button mat-raised-button class="button-text-color" (click)="close()">Cancel</button>
        <button mat-raised-button class="button-text-color" (click)="save()" [disabled]="form?.invalid || form?.pristine">
            <mat-icon aria-hidden="true" class="button-text-color">save</mat-icon>
            Save
        </button>
    </div>
</div>
